(ns manage.duplicate-adset-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            [cljs-bean.core :refer [->clj]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.adset :as q]
            [common.resource.query.campaign :as cq]
            [common.util :refer [spread-obj]]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.radio :refer [radio-group]]
            [manage.adset.util :as adset-util]
            [manage.duplicate-adset-ocp.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui content-function-version-field []
  (let [contains-published? (use-subscribe [:resource.content-function-version/contains-version? "published"])
        contains-draft? (use-subscribe [:resource.content-function-version/contains-version? "draft"])
        set-type (fn [value] (rf/dispatch [:form.adset-duplicate/on-change [:duplicate] value]))]
    ($ form-field
       {:label "Content Function to include"
        :err-msg (form/use-error-message [:duplicate])}
       (r/as-element
        [radio-group (merge (form/use-bind-control [:duplicate])
                            {:options [{:label "Published Content Function"
                                        :value :published
                                        :disabled? (not contains-published?)
                                        :on-select #(set-type :published)}
                                       {:label "Draft Content Function"
                                        :value :draft
                                        :disabled? (not contains-draft?)
                                        :on-select #(set-type :draft)}]})]))))

(defn ->campaign-options [data]
  (->> (->clj data)
       (filterv #(or (seq (:adset2Ids %))
                     (and (empty? (:adset2Ids %))
                          (empty? (:adsetIds %)))))
       (map (fn [{:keys [name id]}]
              {:label name :value id}))))

(defocp duplicate-adset-ocp :adset/duplicate []
  (uix/use-effect (fn []
                    (rf/dispatch [:form.adset-duplicate/init-form])
                    (fn []
                      (rf/dispatch [:form.adset-duplicate/destroy])))
                  [])
  (let [url-context (use-subscribe [:url-context])
        versions (use-subscribe [:resource.content-function-version/versions])
        {:keys [include-content-function] :as form-value} (use-subscribe [:form.adset-duplicate/value []])

        {duplicate-adset :mutate} (use-mutation (q/duplicate-adset-mutation url-context))
        on-duplicate-success (fn [^js response]
                               (rf/dispatch [:ocp/close])
                               (adset-util/navigate-to-landing-page (.-workflow response)
                                                                    (assoc url-context
                                                                           :adset-id (.-id response)
                                                                           :campaign-id (.-campaignId response))))
        on-duplicate-failure (fn [response]
                               (rf/dispatch [:form.adset-duplicate/submit-failure (->clj response)]))

        {campaign-options :data} (use-query (spread-obj (cq/campaigns-query url-context)
                                                        #js {:select ->campaign-options}))]
    ($ ocp
       {:title "Duplicate an Adset"
        :on-submit #(duplicate-adset (dissoc form-value :include-content-function)
                                     #js {:onSuccess on-duplicate-success
                                          :onError on-duplicate-failure})
        :footer ($ Button {:type "submit"
                           :variant "contained"}
                   "Duplicate Adset")}
       ($ form-field
          {:label "New Adset name"
           :err-msg (form/use-error-message [:name])}
          ($ input
             (merge (form/use-bind-control [:name])
                    {:type "text"
                     :data-testid :duplicate-adset-name-input})))
       ($ form-field
          {:label "Target Campaign"}
          (r/as-element
           [dropdown (merge (form/use-bind-control [:campaignId])
                            {:options campaign-options
                             :data-test-id :duplicate-adset-campaign-select})]))
       ($ form-field
          {:label "What do you want to include?"}
          ($ Stack {}
             ($ checkbox
                (merge (form/use-bind-control [:include-content-function]
                                              {:on-change-event :form.adset-duplicate/on-change-include-cfn})
                       {:label "Content Function"
                        :id :include-content-function
                        :disabled? (empty? versions)
                        :data-testid :duplicate-adset-content-function-checkbox}))
             ($ checkbox
                (merge (form/use-bind-control [:includeTemplate])
                       {:label "Templates"
                        :id :includeTemplate
                        :data-testid :duplicate-adset-templates-checkbox}))))
       (when include-content-function
         ($ content-function-version-field)))))
